
import { Vue, Prop, Component } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    Header: () => import("@/components/Jobs/Common/Header.vue"),
    ProfileMenu: () => import("@/components/Jobs/Profile/ProfileMenu.vue"),
    OfferCard: () => import("@/components/Jobs/Common/OfferCard.vue"),
    LastNews: () => import("@/components/Jobs/Profile/LastNews.vue"),
    DescriptionOffers: () =>
      import("@/components/Jobs/Common/DescriptionOffers.vue"),
    Slick: () => import("vue-slick")
  }
})
export default class JobsPostulations extends Vue {
  slickOptions = {
    infinite: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "20px",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 499,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };
  offersRecentUser = [];
  offersLast = [];
  lastNews = [];
  offers = [];

  async mounted() {
    if ((this as any).$store.state.token) {
      const response = await (this as any).$root._post(
        "useroffer/filtered_list",
        {
          postulate: 1
        }
      );
      let offers: any = [];
      for (let i: number = 0; i < response.data.length; i++) {
        offers.push({
          ...response.data[i].offer,
          status: response.data[i].status,
          favorite: response.data[i].favorite,
          postulate: response.data[i].postulate,
          postulateDate: response.data[i].createdAt
        });
      }
      (this as any).offers = offers.filter((item: any) => {
        return !item.f_cierre || moment().isBefore(moment(item.f_cierre));
      });
      (this as any).offersLast = offers.filter((item: any) => {
        return item.f_cierre && moment(item.f_cierre).isBefore(moment());
      });
    }
  }

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }

  beforeUpdate() {
    // if (this.$refs.slick) {
    //   (this as any).$refs.slick.destroy();
    // }
  }

  updated() {
    // this.$nextTick(function() {
    //   if (this.$refs.slick) {
    //     (this as any).$refs.slick.create();
    //   }
    // });
  }
}
